import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ArticleMenu } from 'site-modules/shared/components/editorial/article-menu/article-menu';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { getReviewLinksPath } from 'site-modules/shared/utils/upper-funnel/content-path';
import { TYPE_TITLE_LOWERCASE_EXCEPTIONS_MAPPING } from 'site-modules/shared/utils/upper-funnel/type-mapping';

import './suggested-article-links-v2.scss';

const MAX_ARTICLES_NUM = 6;

function trackingValueDecoratorFunction(item) {
  return item.name;
}

export function SuggestedArticleLinksV2UI({ type, linksContent }) {
  const linksContentChildren = linksContent.children();
  if (!(linksContentChildren && linksContentChildren.length)) {
    return null;
  }

  const links = linksContentChildren
    .map(articleLink => ({
      href: articleLink.metadata('item-link').value(),
      name: articleLink.metadata('item-title').value(),
    }))
    .slice(0, MAX_ARTICLES_NUM);

  return (
    <Fragment>
      <ArticleMenu
        data-tracking-parent="edm-entry-articles"
        title={`Latest ${TYPE_TITLE_LOWERCASE_EXCEPTIONS_MAPPING[type] || type} reviews`}
        links={links}
        titleClassName=""
        className="article-menu-wrapper mb-0_5 mb-md-0 mb-lg-2 size-16"
        listClassName="mb-0"
        linksClassName="article-links fw-normal text-cool-gray-30 d-inline-block pb-1_25 pb-md-1_5 pb-lg-1_25"
        titleContainerClassName="article-menu-titleContainer heading-4 pb-1_5 text-cool-gray-10"
        itemsClassName="article-menu-items"
        trackingValueDecorator={trackingValueDecoratorFunction}
        dataTrackingId="view_article"
        dividerClassName="d-none"
        listStyle={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))' }}
      />
    </Fragment>
  );
}

SuggestedArticleLinksV2UI.defaultProps = {
  linksContent: DEFAULT_CONTENT,
};

SuggestedArticleLinksV2UI.propTypes = {
  type: PropTypes.string.isRequired,
  linksContent: CmsEntities.Content,
};

export const SuggestedArticleLinksV2 = connectToModel(SuggestedArticleLinksV2UI, {
  linksContent: bindToContent(({ type }) => getReviewLinksPath(type), 'content-list'),
});

SuggestedArticleLinksV2.propTypes = {
  type: PropTypes.string.isRequired,
};
